import colors from '@loggi/ui/components/utils/colors';
import icons from '@loggi/ui/components/utils/icons';

// REMINDER: need to separate each context to improve maintenance
export const FORM_TEXTS = {
  button: 'Acompanhar pedido'
};

export const STATUS_TITLE_TEXTS = {
  inSender: {
    titlePrefix: 'Seu pedido ',
    titleSufix: ' estará com a Loggi em breve.'
  },
  inLoggi: {
    titlePrefix: 'Seu pedido ',
    titleSufix: ' já está com a Loggi.'
  },
  goingToRecipient: {
    titlePrefix: 'Seu pedido ',
    titleSufix: ' está a caminho.'
  },
  inRecipient: {
    titlePrefix: 'Eba! Já entregamos seu pacote ',
    titleSufix: ' .'
  },
  warningDeliveryDenied: {
    titlePrefix: 'Seu pedido ',
    titleSufix: ' foi recusado no momento da entrega.'
  },
  warningWrongAddress: {
    titlePrefix:
      'A gente não encontrou o endereço, por isso seu pedido não foi entregue. Entre em contato com ',
    titleSufix: ' para mais informações.'
  },
  warningUnavailableNoDate: {
    titlePrefix: 'Não tinha ninguém no lugar para receber o pedido ',
    titleSufix: ', mas a gente já passa uma nova data pra você.'
  },
  warningUnavailableWithDate: {
    titlePrefix: 'Você tem uma nova data de entrega para o pedido ',
    titleSufix: ' porque não tinha ninguém no lugar para receber.'
  },
  warningDelayWithDate: {
    titlePrefix:
      'Você tem uma nova data de entrega, porque não conseguimos entregar o seu pedido ',
    titleSufix: '.'
  },
  warningDelayNoDate: {
    titlePrefix: 'Não conseguimos fazer sua entrega ',
    titleSufix:
      '. Mas não se preocupe, a gente já passa uma nova data pra você.'
  },
  fallbackMessage: {
    titlePrefix:
      'Não conseguimos fazer a entrega. Para mais informações, entre em contato com ',
    titleSufix: '.'
  },
  warningCanceled: {
    titlePrefix: 'Não conseguimos entregar seu pedido. Entre em contato com ',
    titleSufix: ' para mais informações.'
  },
  warningUnavailableCanceled: {
    titlePrefix:
      'Não conseguimos entregar seu pedido porque não tinha ninguém para receber. Entre em contato com ',
    titleSufix: ' para mais informações.'
  }
};

export const STATUS_DISPLAY_INFO_LABEL = {
  newDeliveryDate: 'Nova data de entrega',
  forecastDate: 'Entrega prevista para',
  deliveryDone: 'Entrega concluída',
  trackingKey: 'Código de rastreamento'
};

export const ETA_LABEL = {
  today: 'Hoje',
  todayAt: 'Hoje às '
};

export const IS_PACKAGE_TRACKING_KEY_FORM = {
  title: 'Olá! ',
  span: '😃',
  subtitle: {
    text: 'Acompanhe com a Loggi a entrega do seu pedido. ',
    size: 11
  },
  textContent: 'Primeiro, digite o código de rastreamento.',
  input: {
    label: STATUS_DISPLAY_INFO_LABEL.trackingKey,
    placeholder: '',
    errorMessage: 'Não encontramos pedidos com esse código.'
  },
  buttonValue: FORM_TEXTS.button
};

export const IS_PACKAGE_TRACKING_COMPLEMENT_FORM = {
  title: 'Estamos quase lá!',
  subtitle: {
    text: 'Agora precisamos do CEP do lugar onde será entregue seu pedido.',
    size: 12
  },
  displayInfoLabel: STATUS_DISPLAY_INFO_LABEL.trackingKey,
  input: {
    label: 'CEP',
    placeholder: '00000-000',
    errorMessage: 'Erro ao buscar Pacote, procure o Transportador.'
  },
  buttonValue: FORM_TEXTS.button
};

export const IS_PACKAGE_TRACKING_PHONE_INFO = {
  infoMessage: 'Este número já foi verificado anteriormente. ',
  title: 'Você será notificado sobre sua entrega no celular abaixo:',
  textContent: {
    color: colors.type.SUCCESS
  },
  label: {
    shape: 'circle',
    icon: icons.type.CHECK,
    color: colors.type.SUCCESS
  }
};

export const IS_PACKAGE_TRACKING_PHONE_INPUT = {
  title: 'Quer saber mais sobre a sua entrega? Insira seu celular abaixo.',
  input: {
    placeholder: '(00) 00000-0000',
    errorMessage: 'Informe um número de telefone válido. Não se esqueça do DDD.'
  },
  button: {
    shape: 'circle',
    icon: icons.type.ARROW_FORWARD
  }
};

export const IS_PACKAGE_TRACKING_TOKEN_SCREEN = {
  title: 'Quase lá!',
  subtitle:
    'Digite abaixo o código de verificação que enviamos para você por SMS.',
  textContent: {
    textPrefix: 'Enviado para ',
    textSufix: '. Não chegou?'
  }
};

export const PACKAGE_TRACKING_NO_FORECAST = {
  inSender:
    'Ah, a gente passa pra você a previsão de entrega assim que seu pedido sair da loja. 😃',
  inAnyDestination:
    'Em breve a gente passa uma nova data de entrega pra você. 😃'
};

export const FOOTER_PACKAGE_TRACKING = {
  textContent: 'Se ainda estiver com dúvidas sobre rastreio de pedido, ',
  linkLabel: 'clique aqui',
  linkUrl:
    'https://ajuda.loggi.com/hc/pt-br/sections/115000600108-Status-da-sua-encomenda'
};

export const DEFAULT_ERROR_MESSAGE =
  'Eita! Ocorreu um erro por aqui, tente novamente.';

export const APP_BEYOND_CONTENT = {
  title: 'A melhor solução para envio de encomendas no Brasil.',
  textContent:
    'Alcance mais clientes com entregas locais e nacionais. Com a Loggi, você economiza tempo e dinheiro.',
  buttonContent: 'Enviar agora',
  buttonMobile: 'btn-mobile',
  buttonWeb: 'btn-web'
};

// ACTIONS
// REMINDER: Try to find a better way to do this
export const ACTIONS = {
  SAVE_PRIVATE_PACKAGE: 'savePrivatePackage',
  CREATE_MUTATION_RATING: 'CREATE_MUTATION_RATING',
  CREATE_MUTATION_RATING_NOTES: 'CREATE_MUTATION_RATING_NOTES',
  OPENED_TRACKER: 'OPENED_TRACKER',
  OPENED_RATING: 'OPENED_RATING',
  OPENED_DISPLAY_RATING: 'OPENED_DISPLAY_RATING',
  OPENED_NOTES_RATING: 'OPENED_NOTES_RATING',
  CANCEL_NOTES_RATING: 'CANCEL_NOTES_RATING',
  OPENED_RECEIPTS: 'OPENED_RECEIPTS',
  OPENED_NOTES_RATING_CONFIRMATION: 'OPENED_NOTES_RATING_CONFIRMATION',
  SAVE_HAS_FINISHED_SCREEN_FLOW: 'SAVE_HAS_FINISHED_SCREEN_FLOW',
  SAVE_PHONE_NUMBER: 'SAVE_PHONE_NUMBER',
  SAVE_NEW_DESTINATION_INFO: 'SAVE_NEW_DESTINATION_INFO'
};

export const AMPLITUDE = {
  CREATE_MUTATION_RATING: 'tracker-rating-sent',
  CREATE_MUTATION_RATING_NOTES: 'tracker-rating-notes-sent',
  OPENED_TRACKER: 'tracker-opened',
  OPENED_RATING: 'tracker-rating-opened',
  OPENED_DISPLAY_RATING: 'tracker-rating-summary-displayed',
  OPENED_NOTES_RATING: 'tracker-rating-notes-opened',
  CANCEL_NOTES_RATING: 'tracker-rating-notes-cancelled',
  OPENED_RECEIPTS: 'tracker-presto-receipts-opened',
  OPENED_NOTES_RATING_CONFIRMATION: 'tracker-rating-notes-confirmation-opened'
};

export const FEEDBACK_ALERT_ERROR_TITLE = 'Eita!';
export const RETRY_BUTTON_VALUE = 'Tentar novamente';
export const CLOSE_BUTTON_VALUE = 'Fechar';

export const DESTINATION_TYPES = {
  RESIDENTIAL_BUILDING: {
    LABEL: 'Prédio residencial',
    VALUE: 'RESIDENTIAL_BUILDING',
    TYPE: 'RESIDENTIAL_BUILDING'
  },
  HOUSE: {
    LABEL: 'Casa',
    VALUE: 'HOME',
    TYPE: 'HOUSE'
  },
  COMMERCIAL: {
    LABEL: 'Comercial',
    VALUE: 'COMPANY',
    TYPE: 'COMMERCIAL'
  }
};

export const DESTINATION_OPTIONS = {
  COMMERCIAL: {
    LABEL: 'Comercial',
    TYPE: 'COMMERCIAL'
  },
  RESIDENTIAL: {
    LABEL: 'Residencial',
    TYPE: 'RESIDENTIAL'
  }
};

export const RESIDENTIAL_DESTINATION_TYPES = {
  BUILDING: {
    LABEL: 'Prédio',
    VALUE: 'RESIDENTIAL_BUILDING',
    TYPE: 'RESIDENTIAL_BUILDING'
  },
  HOUSE: {
    LABEL: 'Casa',
    VALUE: 'HOME',
    TYPE: 'HOUSE'
  }
};

// Permissions
export const CAN_CLASSIFY_DESTINATION = 'CAN_CLASSIFY_DESTINATION';
export const CAN_EDIT_FULL_ADDRESS = 'CAN_EDIT_FULL_ADDRESS';

// Polling
export const SECOND_IN_MILLISECONDS = 1000;

export const LOGGIAPP_ORIGIN_IDENTIFYER = 'LOGGIAPP';

// App beyond
export const APP_BEYOND_URL = 'https://app.loggi.com';
